
const testimonialsData = [
  {
    name: 'I. Fati',
    company: 'Matilda Limited',
    quote: `Working with Neka was an absolute pleasure. He was super patient with me, even when my communication wasn’t the best, and he still managed to deliver a website that perfectly captured what I wanted. His creativity, professionalism, and attention to detail really stood out. I’d highly recommend him to anyone looking for a designer who genuinely cares about getting it right.`,
    rating: 1,
  },
  {
    name: 'G. Dosu',
    company: 'Christian Collective',
    quote: `Working with Neka on our website redesign was super great. Neka was professional from day one. We had conversations with three other developers, but we decided to give the project to Neka because he offered a better and more professional package. We are so glad to have partner up with him, he's a great communicator and easy to get hold of. But most importantly, he delivers on what was agreed`,
    rating: 1,
  },
  {
    name: 'R. Zireva',
    company: 'ANREER Investments',
    quote: `Neka provides a quality professional service, and has shown himself to be a person of integrity. What I enjoyed the most is his desire to understand our companies needs whilst opening my eyes to other ideas.`,
    rating: 1,
  },
  {
    name: 'R. Ross',
    company: 'Wayfinding Kaia',
    quote: `I would recommend Neka for his great quality and fast results. What I enjoyed the most about our website is that it was quick and that it looks amazing.`,
    rating: 0.9
  },
  {
    name: 'B. Nwidag',
    company: `Bree's Little Stars`,
    quote: `Neka delivered excellent quality work from start to finish. His consistency, attention to detail, and the final outcome of our website were outstanding. Communication was clear throughout, and the finished product exceeded expectations. Highly recommended.`,
    rating: 0.9
  }
];

export default testimonialsData;